import React, { FC } from "react";
import { useIntl } from "react-intl";
import { OverlayTrigger, Tooltip } from "react-bootstrap-v5";
import { Link, useHistory } from "react-router-dom";
import { HeaderModel } from "../../../models/CommonModel";
import SortableColumn from "../../../components/Table/SortableColumn";
import _ from "lodash";
import { ImportRequestModel } from "../../../models/ImportRequestModel";
import moment from "moment";


type TProps = {
    selectedIds: Array<number>
    data: Array<ImportRequestModel>,
    header: HeaderModel[],
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
    setSelectedIds: (ids: Array<number>) => void
}

const RequestTable: FC<TProps> = ({ data, header, hideCols, selectedIds, openColConfig, handleSort, setSelectedIds }) => {
    const intl = useIntl();
    const history = useHistory();

    const handleRedirectDetail = (item: ImportRequestModel) => history.push({
        pathname: `/warehouse/receipt/import-requests/${item.id}`,
        state: { code: item.code }
    });

    const handleCheckbox = (id: number) => {
        const ids = _.includes(selectedIds, id) ? _.without(selectedIds, id) : [...selectedIds, id];
        setSelectedIds([...ids]);
    }

    const renderStatus = (status: string) => {
        switch (status) {
			case 'draft':
				return <span className={'text-muted'}>Nháp</span>;
			case 'new':
				return <span className={'text-primary'}>Mới</span>;
			case 'preparing':
				return <span className={'text-warning'}>Đang chuẩn bị hàng</span>;
			case 'shipping':
				return <span className={'text-warning'}>Đang giao hàng</span>;
			case 'done':
				return <span className={'text-success'}>Hoàn thành</span>;
            case 'canceled':
				return <span className={'text-danger'}>Đã hủy</span>;
		}
    }

    return <div className='table-responsive'>
        <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
            <thead>
                <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                    <th>
                        <i
                            className="fa fa-cogs"
                            style={{ cursor: 'pointer' }}
                            onClick={openColConfig}
                        ></i>
                    </th>
                    {header.map((th, index) => {
                        if (!hideCols.includes(th.field)) {
                            if (th.sortable) {
                                return (
                                    <SortableColumn
                                        key={'th-' + index}
                                        sortBy={th?.field}
                                        onSortChange={handleSort}
                                        style={th?.style ?? {}}
                                    >
                                        {th.label}
                                    </SortableColumn>
                                )
                            }
                            return (
                                <th style={th?.style ?? {}}>{th.label}</th>
                            )
                        }
                    })}
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {data?.map((item: ImportRequestModel, index: number) => {
                    var checked = _.includes(selectedIds, item.id)
                    return (
                        <tr key={`receipt_${item.id}_${index}`} className='cursor-pointer'>
                            <td>
                                {/* {item.status !== 'Duyệt' && (
                                    <div className="form-check form-check-custom">
                                        <input key={`item_checkbox_${item.id}_${checked}`} className="form-check-input" type="checkbox"
                                            value={item.id}
                                            defaultChecked={checked}
                                            onChange={() => handleCheckbox(item.id ?? 0)}/>
                                    </div>
                                )} */}
                            </td>
                            {!hideCols.includes('code') && (
                                <td onClick={() => handleRedirectDetail(item)}>{item.code}</td>
                            )}
                            {!hideCols.includes('sento_supplier') && (
                                <td onClick={() => handleRedirectDetail(item)}>{item.sento_supplier?.name || ''}</td>
                            )}
                            {!hideCols.includes('status') && (
                                <td onClick={() => handleRedirectDetail(item)}>
                                    {renderStatus(item.status ?? '')}
                                    {(item?.is_incorrect_quality === 1 || item?.is_incorrect_quantity === 1) && (
                                        <><br/><span className="text-bold text-danger">Cần đối soát</span></>
                                    )}
                                </td>
                            )}
                            {!hideCols.includes('created_at') && (
                                <td onClick={() => handleRedirectDetail(item)}>
                                    Tạo: {moment(item.created_at).format('DD-MM-YYYY H:m:s')}<br/>
                                    Cập nhật: {moment(item.updated_at).format('DD-MM-YYYY H:m:s')}
                                </td>
                            )}
                            {!hideCols.includes('note') && (
                                <td onClick={() => handleRedirectDetail(item)}>
                                    {item.note}
                                </td>
                            )}
                            <td>
                                <OverlayTrigger
                                    placement='bottom'
                                    overlay={<Tooltip id='tooltip-receipts'
                                        className="tooltip">{intl.formatMessage({ id: 'COMMON.VIEW' })}</Tooltip>}
                                >
                                    <Link to={{
                                        pathname: `/warehouse/receipt/import-requests/${item.id}`,
                                        state: { receipt_code: item.code }
                                    }}>
                                        <button className="btn btn-icon btn-light-primary w-30px h-30px ps-2 me-2">
                                            <i className="bi bi-eye-fill fs-4 me-2"></i>
                                        </button>
                                    </Link>
                                </OverlayTrigger></td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    </div>
}
export default RequestTable
